import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { TODAY } from '@Components/DateRangeButton';

export default function useDefinitions() {
  const { id: allocationId } = useParams()

  return useMemo(() => ({
    entityName: 'Transaction',
    entityNamePlural: 'Transactions',
    entityNameModule: 'offer',
    defaultParams: {
      allocationId,
    },
    filters: {
      ref_date: {
        $gte: TODAY.start,
        $lte: TODAY.end,
      },
    },
    menuToggle: false,
  }), [allocationId])
}
